import { captureException } from "@sentry/react";
import i18n from "i18next";
import { useState } from "react";
import { device } from "web_myplann/Utils/device";
import type { Language } from "web_myplann/Utils/WebViewModel";

export const useLanguagePicker = () => {
	const [isOpen, setIsOpen] = useState(false);

	const select = async (language: Language) => {
		setIsOpen(false);

		if (window.ReactNativeWebView) {
			await device.switchLanguage(language).catch(captureException);
		} else {
			i18n.changeLanguage(language);
		}
	};

	return {
		isOpen,
		open: () => setIsOpen(true),
		close: () => setIsOpen(false),
		select,
	};
};
